const getLocalizedName = (word, language) => {
  const keys = {
    'en-US': {
      'en-US': 'English',
      fi: 'Englanti',
      de: 'Englisch',
    },
    fi: {
      'en-US': 'Finnish',
      fi: 'Suomi',
      de: 'Finnisch',
    },
    de: {
      'en-US': 'German',
      fi: 'Saksa',
      de: 'Deutsch',
    },
  };

  return keys[word][language];
};

export default getLocalizedName;
